import { localDate } from './datetime';
export const loanRemaining = loan => Math.max(0, Number(loan.remaining ?? (loan.totalDue - loan.repaid)));
export const loanStatus = loan => loanRemaining(loan) === 0 ? 'Settled' : loan.dueDate && loan.dueDate < localDate(new Date()) ? 'Overdue' : 'Open';
import i18n from './i18n';
export const currencyAmount = (amount, currency) => new Intl.NumberFormat(i18n.resolvedLanguage, { style: 'currency', currency }).format(amount || 0);
export const loanSummary = loans => loans.reduce((result, loan) => {
  const remaining = loanRemaining(loan);
  result.issued += loan.principal; result.repaid += loan.repaid; result.outstanding += remaining;
  if (remaining > 0) result.open += 1;
  if (loanStatus(loan) === 'Overdue') { result.overdue += remaining; result.overdueCount += 1; }
  return result;
}, { issued: 0, repaid: 0, outstanding: 0, open: 0, overdue: 0, overdueCount: 0 });